import { render, staticRenderFns } from "./ItinerariesTable.vue?vue&type=template&id=65f08fe1&scoped=true"
import script from "./ItinerariesTable.vue?vue&type=script&lang=js"
export * from "./ItinerariesTable.vue?vue&type=script&lang=js"
import style0 from "./ItinerariesTable.vue?vue&type=style&index=0&id=65f08fe1&prod&scoped=true&lang=less"
import style1 from "./ItinerariesTable.vue?vue&type=style&index=1&id=65f08fe1&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f08fe1",
  null
  
)

export default component.exports